type IdleCallback = () => void;

/**
 * Run non-critical browser work after the initial render has had a chance to
 * settle. The timeout keeps the work from being postponed indefinitely in
 * browsers without requestIdleCallback or on busy pages.
 */
export function scheduleIdleTask(callback: IdleCallback, timeout = 2000): () => void {
  if (typeof window === 'undefined') return () => {};

  if ('requestIdleCallback' in window) {
    const idleId = window.requestIdleCallback(callback, { timeout });
    return () => window.cancelIdleCallback(idleId);
  }

  const timeoutId = window.setTimeout(callback, timeout);
  return () => window.clearTimeout(timeoutId);
}
